import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Col,
  Alert,
  ProgressBar,
  Form,
  Container,
  Row,
  InputGroup,
} from "react-bootstrap";
import { Utils, UserContext } from "./../../common";
import { useLocation } from "react-router-dom";
import moment from "moment";

import MessageModal from "./../../components/MessageModal";

const Login = (props) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(false);
  const [switchTo, setSwitchTo] = useState(1); // 1 for login view, 2 for forgot password view
  const [askOTP, setAskOTP] = useState(false);
  const [email, setEmail] = useState("");
  const [eyeMode, setEyeMode] = useState(0);

  const { goLogin, goFrgpwd, goImpersonate } = useContext(UserContext);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const usr = queryParams.get("usr");
  const mode = queryParams.get("mode");

  const impersonateMe = (success, message) => {
    if (success) {
      window.setTimeout(function () {
        //console.log(Utils.getUserData());
        window.location.href = process.env.PUBLIC_URL + "/dashboard";
      }, 100);
    } else {
      window.alert(message);
    }
  };

  useEffect(() => {
    if (mode === "impersonate" && usr != "") {
      goImpersonate({ email: usr }, impersonateMe);
    } else if (Utils.isLoggedIn()) {
      window.location.href = process.env.PUBLIC_URL + "/dashboard";
    }
  }, []);

  const [otpTimer, setOtpTimer] = useState(0);
  const [otpTimerTracker, setOtpTimerTracker] = useState(null);

  useEffect(() => {
    if (otpTimer > 0) {
      setOtpTimerTracker(
        window.setTimeout(() => {
          setOtpTimer(otpTimer - 1);
        }, 1000),
      );
    } else if (otpTimerTracker) {
      window.clearTimeout(otpTimerTracker);
      setOtpTimerTracker(null);
    }
  }, [otpTimer]);

  const resendOTP = (e) => {
    setOtpTimer(0);
    setLoading(true);
    goFrgpwd({ email: email }, (success, message) => {
      setLoading(false);
      setMessage([success ? "success" : "error", message]);
      if (success) {
        setOtpTimer(600);
      }
    });
  };

  const submit = (e) => {
    var frm = e.currentTarget;
    e.preventDefault();
    var data = {
      email: frm.email.value,
    };

    if (switchTo === 1) {
      data["password"] = frm.password.value;
    } else if (askOTP) {
      data["new_password"] = frm.new_password.value;
      data["otp"] = frm.otp.value;

      if (frm.new_password.value !== frm.conf_password.value) {
        setMessage(["error", "New Passwords not matching."]);
        return false;
      }
    } else {
      setEmail(data.email);
    }

    setLoading(true);
    (switchTo === 1 ? goLogin : goFrgpwd)(data, authCallback);
  };

  let authCallback = (success, message) => {
    setLoading(false);
    setMessage([success ? "success" : "error", message]);
    if (success) {
      if (switchTo === 1) {
        window.setTimeout(function () {
          //console.log(Utils.getUserData());
          window.location.href = process.env.PUBLIC_URL + "/dashboard";
        }, 100);
      } else {
        if (askOTP) {
          setOtpTimer(0);
          setAskOTP(false);
          setSwitchTo(1);
        } else {
          console.log("start otp counter");
          setAskOTP(true);
          setOtpTimer(600);
        }
      }
    }
  };

  const getEyeSrc = () => {
    let em = [
      `${process.env.PUBLIC_URL}/EyeClosed.png`,
      `${process.env.PUBLIC_URL}/EyeOpen.png`,
    ];
    return em[eyeMode ? 1 : 0];
  };

  return (
    <Container>
      {mode !== "impersonate" && (
        <Row>
          <Col
            sm={12}
            className="p-0 d-block d-sm-none"
            style={{
              background: ` url(${process.env.PUBLIC_URL}/images/logo-bg-xs.png) no-repeat`,
            }}
          >
            <div className="login-bgbox h-100" />
            <h1 className="login-boxtxt">
              <small className="d-block">Welcome back to</small>{" "}
              <img
                src={`${process.env.PUBLIC_URL}/images/logo_white.png`}
                style={{ width: "150px" }}
                alt={process.env.REACT_APP_APPNAME}
              />
            </h1>
          </Col>
          <Col
            sm={12}
            lg={6}
            className="p-0 d-none d-sm-block"
            style={{
              background: ` url(${process.env.PUBLIC_URL}/images/logo-bg-lg.png)`,
            }}
          >
            <div className="login-bgbox d-flex align-items-center text-center justify-content-center h-100">
              <h1 className="text-white">
                <small className="d-block">Welcome back to</small>{" "}
                <img
                  src={`${process.env.PUBLIC_URL}/images/logo_white.png`}
                  alt={process.env.REACT_APP_APPNAME}
                />
              </h1>
            </div>
          </Col>
          <Col sm={12} lg={6}>
            <div className="login_form">
              <div className="login_form_inner">
                <h2 className="mb-4">
                  {switchTo === 1
                    ? "Denttrack Software Login"
                    : "Forgot Password"}
                </h2>

                {message && (
                  <MessageModal
                    type={message[0]}
                    message={message[1]}
                    onHide={() => {
                      setMessage(false);
                    }}
                  />
                )}

                {loading && (
                  <Alert variant="light" className="p-3">
                    <p className="loading-msg">Authorization check</p>
                    <ProgressBar variant="info" animated now={100} />
                  </Alert>
                )}

                {!loading && (
                  <>
                    <Form onSubmit={submit} className="mb-4 pb-4">
                      <InputGroup size="lg" className="mb-3">
                        <InputGroup.Text id="inputGroup-sizing-lg">
                          <img
                            src={`${process.env.PUBLIC_URL}/user.png`}
                            alt="User"
                          />
                        </InputGroup.Text>
                        <Form.Control
                          type="email"
                          name="email"
                          placeholder="Enter Username"
                          defaultValue={email}
                          required
                          readOnly={askOTP}
                        ></Form.Control>
                      </InputGroup>

                      {switchTo === 2 && askOTP && (
                        <>
                          <InputGroup size="lg" className="mb-1">
                            <InputGroup.Text
                              id="inputGroup-sizing-lg"
                              style={{ width: 200 }}
                            >
                              Enter OTP
                            </InputGroup.Text>
                            <Form.Control
                              type="text"
                              name="otp"
                              placeholder="XXXXXX"
                              required
                            ></Form.Control>
                          </InputGroup>

                          <Row className="m-0 mb-3 p-0">
                            <Col>
                              {otpTimer > 0 && (
                                <>
                                  OTP expires in:{" "}
                                  <b className="text-success">
                                    {moment()
                                      .minutes(0)
                                      .seconds(otpTimer)
                                      .format("mm:ss")}
                                  </b>
                                </>
                              )}
                              {otpTimer <= 0 && (
                                <b className="text-danger">OTP has expired!</b>
                              )}
                            </Col>
                            <Col>
                              Not received?{" "}
                              <span
                                className="btn btn-primary p-0 px-1 clickable"
                                onClick={resendOTP}
                              >
                                resend
                              </span>
                            </Col>
                          </Row>

                          <InputGroup size="lg" className="mb-3">
                            <Form.Control
                              type="password"
                              name="new_password"
                              placeholder="New Password"
                              required
                            ></Form.Control>
                          </InputGroup>
                          <InputGroup size="lg" className="mb-3">
                            <Form.Control
                              type="password"
                              name="conf_password"
                              placeholder="Confirm Password"
                              required
                            ></Form.Control>
                          </InputGroup>
                        </>
                      )}

                      {switchTo === 1 && (
                        <InputGroup size="lg" className="mb-3">
                          <InputGroup.Text id="inputGroup-sizing-lg">
                            <img
                              src={`${process.env.PUBLIC_URL}/password.png`}
                              alt="Password"
                            />
                          </InputGroup.Text>
                          <Form.Control
                            type={eyeMode ? "text" : "password"}
                            name="password"
                            placeholder="Password"
                            required
                          ></Form.Control>
                          <InputGroup.Text id="inputGroup-sizing-lg">
                            <img
                              src={getEyeSrc()}
                              onClick={() => {
                                setEyeMode(!eyeMode);
                              }}
                              alt="Show/Hide Password"
                            />
                          </InputGroup.Text>
                        </InputGroup>
                      )}

                      <div className="d-flex justify-content-between">
                        {switchTo === 1 && (
                          <span
                            className="my-4 remember text-decoration-none clickable"
                            onClick={() => setSwitchTo(2)}
                          >
                            Forgot password?
                          </span>
                        )}
                        {switchTo === 2 && (
                          <span
                            className="my-4 remember text-decoration-none clickable"
                            onClick={() => setSwitchTo(1)}
                          >
                            Try Logging in!
                          </span>
                        )}
                      </div>

                      <div className="d-grid">
                        <Button
                          variant="primary"
                          size="lg"
                          className="login-btn"
                          type="submit"
                        >
                          {switchTo === 1
                            ? "Login"
                            : (askOTP ? "Reset" : "Forgot") + " Password"}
                        </Button>
                      </div>
                    </Form>
                    <hr className="my-4" />
                    <h2 className="mt-4">Denttrack Student Login</h2>
                    <div className="d-grid">
                      <Button
                        variant="primary"
                        size="lg"
                        className="login-btn"
                        onClick={() => {
                          window.open(
                            "https://training.denttrack.co.uk/auth?no_redirect",
                            "_blank",
                          );
                        }}
                      >
                        Student Login
                      </Button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </Col>
        </Row>
      )}
      {mode === "impersonate" && <h1>Requesting to Impersonate user {usr}</h1>}
    </Container>
  );
};

export default Login;
